export enum ThankYouTranslations {
  title = 'thankYou.title',
  description = 'thankYou.description',
  message = 'thankYou.message',
  button = 'thankYou.button',
}
